import React, { useEffect, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
  checkString,
  decryptData,
  mobileNumber,
  noDataFound,
  splitDate,
  splitDateSlash,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../../Configuration/API_URL";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import { partner_Api } from "../../../Configuration/Partner_URL";
import { axiosSsoJsonReserv1 } from "../../../CommonMethhods/axiosPartnerInterceptor";

function PartnerClientSummary(props) {
  // const riskProfile = props.riskProfileData;
  const PartnerClientCode = localStorage.getItem("ClientId2");
  const storeToken = localStorage.getItem("ssoToken");
  const [clientSum, setClientSum] = useState();
  const [loader, setLoader] = useState(true);
  const [serverError, setServerError] = useState("");
  let clientCode = "";
  let clientPan =
    localStorage.getItem("panId") || localStorage.getItem("clientPan");

    const getClientSummary = async (clientCode) => {
      let payloadValue = { ClientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
      try {
        const clientSummaryData = await axiosSsoJsonReserv1.post(
          DASHBOARD_CLIENT_OVERVIEW.ClientSummary_URL,
          `"${encPayload}"`,
        );
        const clientSummaryResp = ApiResDecrypt(clientSummaryData?.data);
        // let decryptResp = JSON.parse(clientSummaryResp);
        setClientSum(clientSummaryResp?.data);
        setLoader(false);
      } catch (error) {
        console.log(error);
        setLoader(false);
        setServerError("Something went wrong, Please try again later.");
      }
    };
  useEffect(() => {
    if (PartnerClientCode) {
      clientCode = PartnerClientCode;
      getClientSummary(clientCode);
    } 
  }, []);

  return (
    <>
      <div className="col-12 col-lg-6 bottom-ipad-20 mobile-bottom-20">
        <div className="card-box">
          <div className="card-title">
            <h2>{Constants.Client_Summary}</h2>
          </div>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <div className="client-summary">
              {clientSum && clientSum ? (
                <>
                  <ul className="client-ul">
                    <li className="client-li">
                      <p className="client-p">{Constants.Client_Code}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum?.PARTY_CODE || "-")}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.DP_no}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum?.CLTDPID || "-")}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.Last_Traded_Date}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString &&
                                splitDateSlash(clientSum?.LAST_TRADE_DATE || "-")}
                          </>
                        )}
                      </h5>
                    </li>
                  </ul>
                  <ul className="client-ul">
                    <li className="client-li">
                      <p className="client-p">{Constants.Primary_Bank}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum?.BANK_NAME || "-")}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.Account_no}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(mobileNumber(clientSum?.AC_NUM) || "-")}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.IFSC_CODE}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum?.IFSC || "-")}
                          </>
                        )}
                      </h5>
                    </li>
                  </ul>
                  <ul className="client-ul">
                    <li className="client-li">
                      <p className="client-p">{Constants.Dealer_Name_Code}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum?.DEALER_CODE || "-")}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.RM_Name_Code}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum?.RM_CODE || "-")}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.Branch_Name_Code}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum?.BRANCH_CD || "-")}
                          </>
                        )}
                      </h5>
                    </li>
                  </ul>
                  <ul className="client-ul">
                    <li className="client-li">
                      <p className="client-p">{Constants.Mobile}</p>
                      <h5 className="client-h5 segment-client">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString((clientSum?.mobile || "-"))}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.Segments}</p>
                      <h5 className="client-h5 segment-client">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum?.segment || "-")}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">PAN No</p>
                      <h5 className="client-h5 segment-client">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>{mobileNumber(clientPan) || "-"}</>
                        )}
                      </h5>
                    </li>
                  </ul>
                </>
              ) : serverError ===
                "Something went wrong, Please try again later." ? (
                <h4 className="no-data">{serverError}</h4>
              ) : (
                noDataFound()
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default PartnerClientSummary;
